/** @typedef {import('./NotifySubscribe.svc')} Types */

export class NotifySubscribe {
	constructor($rootScope) {
		'ngInject';
		this.rootScope = $rootScope;
	}
	/**
	 * @param {string} event
	 * @param {unknown} [data]
	 */
	notify(event, data) {
		this.rootScope.$emit(event, data);
	}

	/**
	 * @param {*} scope
	 * @param {string} eventName
	 * @param {Function} callback
	 */
	subscribe(scope, eventName, callback) {
		var handler = this.rootScope.$on(eventName, callback);
		scope.$on('$destroy', handler);
	}
}
//
let svcMod = angular.module('mod.svc.NotifySubscribe', []).service('NotifyingService', NotifySubscribe);
export default (svcMod = svcMod.name);
